import { configureStore } from './configureStore';
import editor from '../reducers/editor';

const editorStore = initialState =>
  configureStore(initialState, {
    editor,
    meta: () => initialState.meta, // no need to reduce this state branch
  });

export default editorStore;
